const { REACT_APP_VERSION = '', REACT_APP_NAME = '', REACT_APP_CI_COMMIT_SHORT_SHA = 'local' } = process.env;

const name = REACT_APP_NAME.replace('@tradetrax/', '');
const sha = REACT_APP_CI_COMMIT_SHORT_SHA || 'local';

export const appVersion = `${name} - ${REACT_APP_VERSION} - ${sha}`;
